import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import styled from 'styled-components'

export type FadeToggleProps = {
  duration?: number
  visible?: boolean
  className?: string
  currentKey?: string
}

const FadeToggle = styled<React.FC<FadeToggleProps>>(
  ({ visible, duration = 300, currentKey = 'contents', ...props }) => {
    return (
      <TransitionGroup>
        {visible && (
          <CSSTransition key={currentKey} classNames="cs" timeout={duration}>
            <div {...props} />
          </CSSTransition>
        )}
      </TransitionGroup>
    )
  }
)`
  &.cs-enter {
    opacity: 0;
  }

  &.cs-enter-active {
    opacity: 1;
    transition: opacity ${({ duration = 300 }) => duration}ms;
  }

  &.cs-exit {
    opacity: 1;
  }

  &.cs-exit-active {
    opacity: 0;
    transition: opacity ${({ duration = 300 }) => duration}ms;
  }
`

export const MoveUp = styled.div`
  ${FadeToggle}.cs-enter > & {
    transform: translateY(20%);
  }

  ${FadeToggle}.cs-enter-active > & {
    transition: transform 0.3s ease-out;
    transform: translateY(0);
  }

  ${FadeToggle}.cs-exit > & {
    transform: translateY(0);
  }

  ${FadeToggle}.cs-exit-active > & {
    transition: transform 0.3s ease-in;
    transform: translateY(20%);
  }
`

export const MoveLeft = styled.div`
  ${FadeToggle}.cs-enter > & {
    transform: translateX(20%);
  }

  ${FadeToggle}.cs-enter-active > & {
    transition: transform 0.3s ease-out;
    transform: translateX(0);
  }

  ${FadeToggle}.cs-exit > & {
    transform: translateX(0);
  }

  ${FadeToggle}.cs-exit-active > & {
    transition: transform 0.3s ease-in;
    transform: translateX(20%);
  }
`

export default FadeToggle
